import { httpClient } from "@api/http";
import type { User } from "@maeiz/core";
import type { BroadcastConfig } from "@lib/broadcast";

export interface LoginRequest {
    email: string;
    password: string;
}

export interface LoginResponse {
    message: string;
    accessToken: string;
    token?: string;
    tokenType: string;
    user: User;
    role?: string;
    broadcast?: BroadcastConfig;
}

export interface CheckAuthResponse {
    message: string;
    user: User;
    broadcast?: BroadcastConfig;
}

export interface MeResponse {
    user: User;
    role: string;
    permissions: string[];
    broadcast?: BroadcastConfig;
}

export interface UpdateProfileRequest {
    name: string;
    email?: string;
    phone?: string;
}

export interface UpdateProfileResponse {
    user: User;
    message: string;
}

export interface ChangePasswordRequest {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export interface ChangePasswordResponse {
    message: string;
}

export interface UpdateProfilePictureResponse {
    message: string;
    user: User;
}

export interface VerifyOtpResponse {
    message?: string;
    verified?: boolean;
}

export interface ResetPasswordRequest {
    email: string;
    otp: string;
    password: string;
    confirmPassword: string;
}

export interface RefreshTokenResponse {
    message?: string;
    accessToken?: string;
    token?: string;
    user?: User;
}

export const authApi = {
    login: (data: LoginRequest) => httpClient.post<LoginResponse>("/auth/login", data),
    logout: () => httpClient.post("/auth/logout"),
    forgotPassword: (email: string) =>
        httpClient.post<{ message: string }>("/auth/forgot-password", { email }),
    verifyOtp: (email: string, otp: string) =>
        httpClient.post<VerifyOtpResponse>("/auth/verify-otp", { email, otp }),
    resetPassword: (data: ResetPasswordRequest) =>
        httpClient.post<{ message: string }>("/auth/reset-password", {
            email: data.email,
            otp: data.otp,
            password: data.password,
            confirm_password: data.confirmPassword,
        }),
    refreshToken: () => httpClient.post<RefreshTokenResponse>("/auth/refresh-token"),
    checkAuth: () => httpClient.post<CheckAuthResponse>("/auth/check-auth", {}),
    me: () => httpClient.get<MeResponse>("/auth/me"),
    updateProfile: (data: UpdateProfileRequest) =>
        httpClient.post<UpdateProfileResponse>("/auth/update-profile", data),
    changePassword: (data: ChangePasswordRequest) =>
        httpClient.post<ChangePasswordResponse>("/auth/change-password", data),
    updateProfilePicture: (file: File) => {
        const formData = new FormData();
        formData.append("profilePicture", file);
        return httpClient.post<UpdateProfilePictureResponse>(
            "/auth/update-profile-picture",
            formData
        );
    },
};
